import { handleActions } from 'redux-actions';
import { PolicyMap } from 'types';
import {
    PoliciesLoadRequestAction,
    PoliciesLoadSuccessAction,
    PoliciesLoadFailureAction,
    PoliciesChangedAction,
} from 'actions/policyActions';
import { LogoutAction } from 'actions/shellActions';

export type State = Readonly<{
    data: Readonly<PolicyMap>;
    loading: boolean;
    error: Error | null;
}>;

export const initialState = Object.freeze<State>({
    data: {},
    loading: false,
    error: null,
});

export type ReducerAction =
    PoliciesLoadRequestAction
    | PoliciesLoadSuccessAction
    | PoliciesLoadFailureAction
    | PoliciesChangedAction
    // Shell Actions
    | LogoutAction
;

export type Reducer = (state: State, action: ReducerAction) => State;

export const policyReducer: Reducer = handleActions({
    POLICIES_LOAD_REQUEST(state: State, action: PoliciesLoadRequestAction) {
        return {
            ...state,
            loading: true,
            error: null,
        };
    },

    POLICIES_LOAD_SUCCESS(state: State, action: PoliciesLoadSuccessAction) {
        return {
            ...state,
            data: action.payload,
            loading: false,
            error: null,
        };
    },

    POLICIES_LOAD_FAILURE(state: State, action: PoliciesLoadFailureAction) {
        return {
            ...state,
            loading: false,
            error: action.payload,
        };
    },

    /* TODO
    POLICIES_CHANGED(state: State, action: PoliciesChangedAction) {

    },
    */


    //
    //  Shell Actions
    //
    LOGOUT(state: State, action: LogoutAction) {
        return initialState;
    },

// tslint:disable-next-line:no-any
} as any, initialState) as any;



// WEBPACK FOOTER //
// ./src/reducers/policyReducer.ts